import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './alphabet-nav.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class AlphabetNav extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      active: { type: String },
      letters: { type: Array },
      description: { type: String },
    };
  }

  constructor() {
    super();
    this.letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
    this.description = '';
    [this.href] = window.location.href.split('#');
  }

  render() {
    return html`
      <div class="alphabet-nav__wrapper">
        <div class="alphabet-nav__description">${this.description}</div>
        <nav class="alphabet-nav__nav" role="navigation" title="${this.title}">
          <ul
            class="${classMap({
              'alphabet-nav__list': true,
            })}"
          >
            ${this.letters.map(letter => {
              return html`<li class="alphabet-nav__item">
                <a
                  href="${this.href}#alphabet-card--${letter}"
                  target="_self"
                  class="${classMap({
                    'active': this.active === letter,
                    'alphabet-nav__link': true,
                  })}"
                >
                  ${letter}
                </a>
              </li>`;
            })}
          </ul>
        </nav>
      </div>
    `;
  }
}
customElements.define('hf-alphabet-nav', AlphabetNav);
